module.exports = __webpack_public_path__ + "static/limpid-markets-illustration-23cefcb2708226ab47092bbd1870935b.svg";